import { baseUrl } from '@fs/zion-config'
import { useLocation } from '@fs/zion-router'

export default () => {}

export function addUrlKeyValue(key, value) {
  if (value) {
    return `${key}=${encodeURIComponent(value)}`
  }
  return ''
}

export function addUrlQueryParams(url, params = {}) {
  if (!params || typeof params !== 'object') return url
  const [u, hash = ''] = url.split('#')
  const [base, q = ''] = u.split('?')
  const sp = new URLSearchParams(q)
  Object.entries(params)
    .filter(([, v]) => v != null && v !== '')
    .forEach(([k, v]) => {
      sp.set(k, v)
    })
  const qs = sp.toString()
  let result = base
  if (qs || hash) {
    const parts = [result]
    if (qs) {
      parts.push('?', qs)
    }
    if (hash) {
      parts.push('#', hash)
    }
    result = parts.join('')
  }
  return result
}

export function deleteLastPathElement(path) {
  if (path && path.indexOf('/') !== -1) {
    const array = path.split('/')
    array.pop()
    return array.join('/')
  }
  return path
}

export function useQueryParams() {
  const location = useLocation()
  return new URLSearchParams(location.search)
}

export function getBackendBaseUrl() {
  const path = '/service/dmc'
  const { REACT_APP_DMC_SERVER } = process.env
  if (REACT_APP_DMC_SERVER === 'localhost') {
    return 'http://localhost:8080'
  }
  return baseUrl + path
}

export function getFrontendBaseUrl(external) {
  let base = baseUrl
  if (external) {
    return base
  }
  if (window.location.hostname !== 'localhost') {
    base = `${base}/dmconsole`
  } else {
    base = window.location.origin
  }
  return base
}
